const locale = {
    placeholder: 'Zeit auswählen',
};
export default locale;
